export const OPTIONS_CATEGORY = [
  'Agriculture Bio Engineering',
  'Anthropology Archeology',
  'Biology',
  'Business Management',
  'Chemistry',
  'Communication Journalism',
  'Computer Technology',
  'Dataset Of Datasets',
  'Deep Learning',
  'Demography',
  'Earth Climate',
  'Economics Finance',
  'Engineering',
  'Health Medicine',
  'History',
  'Image Recognition',
  'Interdisciplinary',
  'Language',
  'Law',
  'Mathematics',
  'Other',
  'Performing Arts',
  'Philosophy',
  'Physics Energy',
  'Politics',
  'Psychology',
  'Sociology',
  'Space Astronomy',
  'Sports Recreation',
  'Theology',
  'Transportation',
  'Urban Planning',
  'Visual Arts Design'
];

export const OPTIONS_LICENSE = [
  'CC BY-NC-ND: Attribution-NonCommercial-NoDerivatives 4.0 International',
  'CC BY-NC-SA: Attribution-NonCommercial-ShareAlike 4.0 International',
  'CC BY-NC: Attribution-NonCommercial 4.0 International',
  'CC BY-ND: Attribution-NoDerivatives 4.0 International',
  'CC BY-SA: Attribution-ShareAlike 4.0 International',
  'CC BY: Attribution 4.0 International',
  'CC0: Public Domain Dedication',
  'CDLA-Permissive: Community Data License Agreement',
  'CDLA-Sharing: Community Data License Agreement',
  'ODC-By: Attribution License',
  'ODC-ODbL: Open Database License',
  'PDDL: Public Domain Dedication and License',
  'Public Domain'
];
